// src/config/index.js

'use strict';

if (typeof WEBPACK_ENV !== 'undefined') {
  module.exports = require('@htmlacademy/compile-loader!./wrapper');
} else {
  // For testing
  module.exports = {};
}
